module.exports = __webpack_public_path__ + "media/images/copy-e4aecdecb8ebada36b8d4cd50a028593.png";